var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SiteMenuFlyoutLayout",
    {
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("div", { staticClass: "mb-8" }, [
        _c("a", { staticClass: "text-lg", attrs: { href: "/" } }, [
          _vm._v("Our Difference"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-6 gap-ogs-large" },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "col-span-3 md:col-span-2" },
            [
              _c("a", { staticClass: "block", attrs: { href: item.url } }, [
                _c("div", { staticClass: "h-0 pt-full relative mb-4" }, [
                  item.image.length
                    ? _c("img", {
                        staticClass:
                          "absolute inset-0 w-full h-full object-cover",
                        attrs: {
                          src: item.image[0].url,
                          alt: item.image[0].title,
                        },
                      })
                    : _c("div", {
                        staticClass: "absolute inset-0 w-full h-full bg-grey",
                      }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "text-md" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }